/* public function enrolments() {
        $online_expiry_from = $this->postParams["online_expiry_from"];
        $online_expiry_to = $this->postParams["online_expiry_to"];
        $product_id = $this->postParams["product_id"];
        $product_type = $this->postParams["product_type"];
        $customer_country = $this->postParams["customer_country"];
        $online_passed = $this->postParams["online_passed"];
        $classroom_passed = $this->postParams["classroom_passed"];
        $order_date_from = $this->postParams["order_date_from"];
        $order_date_to = $this->postParams["order_date_to"];

        if(!strlen($online_expiry_from) && !strlen($online_expiry_to) && !strlen($order_date_from) && !strlen($order_date_to)) {
            throw new Exception("You must specify atleast an expiry date from or expiry date to value");
        }

        $sql = "
        SELECT 
        
        C.id,
        C.firstname,
        C.lastname,
        C.email,
        CA.country,
        CA.postcode,
        P.id,
        P.name,
        P.type,
        OBP.onlineCourseExpiryDate,
        OBP.onlineCoursePassed,
        OBP.classRoomCoursePassed,
        O.dateCreated,
        L.domain
        
        FROM `Order` O 
        
        -- customer
        LEFT JOIN Core_Relationship L0 ON 
        L0.leftClassName = ('Order') AND 
        L0.leftInstanceId = O.id AND 
        L0.rightClassName = ('Customer') AND 
        L0.leftToRightProperty = ('customer')
        
        LEFT JOIN Customer C ON 
        C.id = L0.rightInstanceId
        
        -- obp
        LEFT JOIN Core_Relationship L1 ON 
        L1.leftClassName = ('Order') AND 
        L1.leftInstanceId = O.id AND
        L1.rightClassName = ('OrderBoughtProduct') AND 
        L1.leftToRightProperty = ('boughtProducts')
        
        LEFT JOIN OrderBoughtProduct OBP ON 
        OBP.id = L1.rightInstanceId
        
        -- address
        LEFT JOIN Core_Relationship L2 ON 
        L2.leftClassName = ('Customer') AND 
        L2.leftInstanceId = C.id AND 
        L2.rightClassName = ('Core_Address') AND 
        L2.leftToRightProperty = ('shippingAddress')
        
        LEFT JOIN Core_Address CA ON 
        CA.id = L2.rightInstanceId
        
        -- product
        LEFT JOIN Core_Relationship L3 ON 
        L3.leftClassName = ('OrderBoughtProduct') AND 
        L3.leftInstanceId = OBP.id AND 
        L3.rightClassName = ('Product') AND 
        L3.leftToRightProperty = ('product')
        
        -- lead
        LEFT JOIN CRM_Lead L ON L.email = C.email
        
        LEFT JOIN Product P ON 
        P.id = L3.rightInstanceId
        ";

        $db = $this->Extorio()->getDbInstanceDefault();

        $where = "
        WHERE 
        O.status = 2 AND 
        P.id > 0 AND P.id IS NOT NULL AND ";

        if(strlen($order_date_from)) {
            $where .= "O.dateCreated >= ('".date("Y-m-d H:i:s", strtotime($order_date_from))."') AND ";
        }
        if(strlen($order_date_to)) {
            $where .= "O.dateCreated <= ('".date("Y-m-d H:i:s", strtotime($order_date_to))."') AND ";
        }

        if(strlen($online_expiry_from)) {
            $where .= "OBP.onlineCourseExpiryDate >= ('".date("Y-m-d H:i:s",strtotime($online_expiry_from))."') AND ";
        }
        if(strlen($online_expiry_from)) {
            $where .= "OBP.onlineCourseExpiryDate <= ('".date("Y-m-d H:i:s",strtotime($online_expiry_to))."') AND ";
        }
        if(strlen($product_id)) {
            $where .= "P.id = ".intval($product_id)." AND ";
        }
        if(strlen($product_type)) {
            $where .= "P.type = ('".$db->clean($product_type)."') AND ";
        }
        if(strlen($customer_country)) {
            $where .= "CA.country = ('".$db->clean($customer_country)."') AND ";
        }
        if($online_passed == "true") {
            $where .= "OBP.onlineCoursePassed = 1 AND ";
        } else {
            $where .= "OBP.onlineCoursePassed = 0 AND ";
        }
        if($classroom_passed == "true") {
            $where .= "OBP.classRoomCoursePassed = 1 AND ";
        } else {
            $where .= "OBP.classRoomCoursePassed = 0 AND ";
        }

        $sql .= substr($where,0,strlen($where)-4);

        $sql .= "
        ORDER BY OBP.onlineCourseExpiryDate DESC
        ";

        $fn = "application/assets/reports/enrolments/".uniqid().".csv";
        $fh = fopen($fn,"w");
        if(!$fh) {
            throw new Exception("Could not create the csv file");
        }

        fputcsv($fh,array(
            "customer id",
            "customer first name",
            "customer last name",
            "customer email",
            "customer country",
            "customer postcode",
            "product id",
            "product type",
            "product name",
            "online expiry date",
            "online passed",
            "classroom passed",
            "order date",
            "lead domain"
        ));

        $db = $this->Extorio()->getDbInstanceDefault();
        $rows = $db->getRowsIndices($sql);
        foreach ($rows as $row) {
            fputcsv($fh,$row);
        }

        fclose($fh);

        $this->output->data = $fn;
} */
<template>
     <el-container>
    <el-main>
      <el-row
        type="flex"
        justify="space-start"
        :gutter="30"
      >
        <el-col :span="18">
          <el-card class="box-card">
            <div class="card-header">
                <h4 class="card-title">Enrollments</h4>
               
     <div class="table-responsive">
                                <el-row style="margin-top:30px; margin-bottom: 10px">
   <el-col :span="5">
                  <label class="control-label">Region:</label><br>
                  <el-select v-model="filters[1].value" placeholder="select region">
                    <el-option label="All" value="ALL"></el-option>
                    <el-option label="UK" value="TEFLORG"></el-option>
                    <el-option label="US" value="TEFLUS"></el-option>
                    <el-option label="EU" value="IRELAND"></el-option>
                    <el-option label="AUS" value="AUSTRALIA"></el-option>
                    <el-option label="CAD" value="CANADA"></el-option>
                  </el-select>
                </el-col>

                <el-col :span="7">
                  <label class="control-label">Select Date Range</label><br>
                  <el-date-picker  
                    v-model="filters[2].value" 
                    type="daterange"
                    align="right" 
                    unlink-panels range-separator="-" 
                    start-placeholder="Start date" 
                    end-placeholder="End date" 
                    :picker-options="pickerOptions1">
                  </el-date-picker>
                </el-col>
                                </el-row>
                            </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
      </el-container>
</template>
<script>
import _ from "lodash";
import gql from "graphql-tag";
import moment from "moment";
export default {
  data() {
    return {
         filters: [
        {
          value: "2",
          prop: "status",
        }, 
        {
          value: "ALL",
          prop: "productPriceLabel"
        },
        {
          value: [
            moment().subtract(1, "months").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ],
          prop: "dateCreated"
        }
         ],
          pickerOptions1: {
        shortcuts: [
          {
            text: "Last 24 hours",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Two Weeks",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "3 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "6 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "1 year",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
          }
    }
  },
  methods:{
getEnrollments(){
    let query=gql``;
    this.$apollo
      .query({
        // desc_nulls_last filters out any null data
        query:query,
        // can get error if needed
        error(error) {
          this.error = JSON.stringify(error);
        }
      })

}
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Reports/Enrollments.vue